// extracted by mini-css-extract-plugin
export default {"container":"DesktopUserEnteringPage_container__rzOde"};